import React from 'react';
import { MapPin, Phone, Clock, Droplet } from 'lucide-react';
import { Button } from '../ui/button';

export const LongpontModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
      data-testid="longpont-modal"
    >
      <div className="relative bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        {/* BANNIÈRE PROMO EN HAUT DU MODAL */}
        <div className="bg-gradient-to-r from-[#0205B3] to-blue-500 text-white py-4 px-6 sticky top-0 z-10" data-testid="longpont-modal-promo">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <span className="bg-red-600 px-3 py-1 rounded text-sm font-bold uppercase">
                Offre Printemps
              </span>
              <span className="text-lg font-bold">
                Nettoyage de couettes
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-2xl line-through opacity-60">25€</span>
              <span className="text-4xl font-black">18€</span>
              <span className="bg-red-600 px-3 py-1 rounded text-xs font-bold">OFFRE LIMITÉE</span>
            </div>
          </div>
        </div>

        {/* BOUTON FERMER */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 z-20 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100"
          data-testid="longpont-modal-close"
          aria-label="Fermer"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* HEADER PRESSING */}
        <div className="bg-[#0205B3] text-white p-8">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-3xl font-bold">Pressing AQUABLUENET</h2>
            <div className="bg-white text-[#0205B3] px-4 py-2 rounded-full text-sm font-bold">
              91310
            </div>
          </div>
          <p className="text-xl text-blue-100">Longpont-sur-Orge</p>
          <p className="text-blue-200 mt-2">Intermarché - Zac des Échassons</p>
        </div>

        {/* CONTENU */}
        <div className="p-8 space-y-6">
          <div className="flex items-start gap-4">
            <MapPin className="h-6 w-6 text-[#0205B3] flex-shrink-0 mt-1" />
            <div>
              <p className="font-bold text-gray-900 text-lg mb-1">Adresse</p>
              <p className="text-gray-600">
                Intermarché<br />
                Galerie marchande du centre commercial<br />
                Zac des Échassons<br />
                91310 Longpont-sur-Orge
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <Phone className="h-6 w-6 text-[#0205B3] flex-shrink-0 mt-1" />
            <div>
              <p className="font-bold text-gray-900 text-lg mb-1">Téléphone</p>
              <a href="tel:0169807375" className="text-[#0205B3] hover:underline text-xl font-medium">
                01 69 80 73 75
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <Clock className="h-6 w-6 text-[#0205B3] flex-shrink-0 mt-1" />
            <div>
              <p className="font-bold text-gray-900 text-lg mb-1">Horaires d'ouverture</p>
              <p className="text-gray-600 text-lg">
                <strong>Mardi - Samedi</strong><br />
                10h00 - 19h00
              </p>
              <p className="text-sm text-red-600 font-medium mt-1">Fermé Dimanche et Lundi</p>
            </div>
          </div>

          <div className="bg-green-50 border-2 border-green-600 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <svg className="h-6 w-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="font-bold text-green-700 text-lg">Carte CleanWay (5àSec business) acceptée</p>
            </div>
            <p className="text-gray-600">Utilisez votre carte <strong>CleanWay</strong> dans ce pressing</p>
          </div>

          <div className="bg-blue-50 border-2 border-blue-600 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Droplet className="h-6 w-6 text-blue-600" />
              <p className="font-bold text-blue-700 text-lg">Technologie Lagoon écologique</p>
            </div>
            <p className="text-gray-600">Nettoyage 0% Perchlo, 100% naturel</p>
          </div>

          <Button
            className="w-full bg-[#0205B3] hover:bg-[#0205B3]/90 text-white py-6 text-lg"
            onClick={() => window.open('https://www.google.com/maps?q=Intermarché+Longpont-sur-Orge+91310', '_blank')}
            data-testid="longpont-modal-map-btn"
          >
            <MapPin className="mr-2 h-5 w-5" />
            Obtenir l'itinéraire vers Longpont
          </Button>
        </div>
      </div>
    </div>
  );
};
